import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);
  const [progress, setProgress] = useState(0);

  const size = 48;
  const strokeWidth = 2;
  const center = size / 2;
  const radius = center - strokeWidth;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      const scrollable = documentHeight - windowHeight;

      const rawProgress = (scrollTop / scrollable) * 100;
      const smoothProgress = Math.min(Math.max(rawProgress, 0), 100);

      setProgress(smoothProgress);
      setShowButton(scrollTop > 300);
    };

    let ticking = false;
    const scrollListener = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", scrollListener, { passive: true });
    return () => window.removeEventListener("scroll", scrollListener);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div
      className={`fixed bottom-6 right-6 transition-opacity duration-300 ${
        showButton ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={scrollToTop}
        className="relative w-12 h-12 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-300 group"
        title="Scroll to Top"
      >
        <svg
          className="absolute inset-0 transform -rotate-90"
          width={size}
          height={size}
        >
          {/* Background circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth={strokeWidth}
          />
          {/* Progress circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="#3b82f6"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className="transition-all duration-300 ease-out"
            strokeLinecap="round"
          />
        </svg>

        {/* Arrow icon */}
        <div className="absolute inset-0 flex items-center justify-center">
          <ArrowUp className="w-6 h-6 text-blue-500 group-hover:text-blue-600 transition-colors duration-200" />
        </div>
      </button>
    </div>
  );
};

export default ScrollToTopButton;
